import confirm from './confirm'
import Vue from 'vue'
const defaults = {
  showFlag: false,
  btnCan: '否',
  btnOk: '是',
  conDesc: `内容`,
  cancelA () {
    this.close()
  },
  confirmA () {
    this.close()
  }
}

let confirmVueLoading
const confirmVueConstructor = Vue.extend(confirm)
// 这里关闭的时候返回promise
confirmVueConstructor.prototype.close = function () {
  var vm = this
  confirmVueLoading = null
  var promise = new Promise(function (resolve, reject) {
    if (vm.$el && vm.$el.parentNode) {
      vm.$el.parentNode.removeChild(vm.$el)
    }
    resolve()
    vm.$destroy()
    vm.showFlag = false
  })
  return promise
}
const confirmBox = (options = {}) => {
  if (Vue.prototype.$isServer) return
  console.log(options)
  options = Object.assign({}, defaults, options)

  let parent = document.body
  console.log('confirmVueLoading', confirmVueLoading)
  // 没有关闭不允许新开
  if (confirmVueLoading) {
    return confirmVueLoading
  }
  // eslint-disable-next-line new-cap
  let instance = new confirmVueConstructor({
    el: document.createElement('div'),
    data: options
  })
  console.log('instance', instance)
  parent.appendChild(instance.$el)
  Vue.nextTick(() => {
    instance.showFlag = true
  })
  confirmVueLoading = instance
  return instance
}

export default confirmBox



// WEBPACK FOOTER //
// ./src/base/confirm/index.js